import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";
import LanguageSettings from "./Services/LanguageService.js";
i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: LanguageSettings.languages,
    debug: true,
    fallbackLng: "en",
    interpolation: {
      escapeValue: false,
    },
    react: {
      useSuspense: true,
    },
  });

export default i18n;
